import { Stage, Layer, Rect, Text } from "react-konva";
import { useCallback, useEffect, useRef, useState } from "react";

export default function RoundStage({ rounds, levels }) {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const stageRef = useRef(null);

  const cellWidth = 200;
  const cellHeight = 60;
  const conLineWidth = 30;
  const yOffset = 100;
  const maxScale = 4;
  const minScale = 0.10;
  const viewportPadding = 24;

  const maxPlayers = Math.pow(2, levels);
  const boardWidth = (levels * 2 - 1) * cellWidth + (levels + 1) * 2 * conLineWidth;
  const boardHeight = yOffset + (maxPlayers / 2) * cellHeight + Math.max(maxPlayers / 4 - 1, 0) * 0.1 * cellHeight + cellHeight;

  const fitStageToScreen = useCallback(() => {
    const stage = stageRef.current;
    if (!stage) {
      return;
    }

    const stageWidth = window.innerWidth;
    const stageHeight = Math.max(window.innerHeight - 64, 1);
    const availableWidth = Math.max(stageWidth - viewportPadding * 2, 1);
    const availableHeight = Math.max(stageHeight - viewportPadding * 2, 1);

    const nextScale = Math.max(
      minScale,
      Math.min(maxScale, Math.min(availableWidth / boardWidth, availableHeight / boardHeight))
    );

    setScale(nextScale);
    setPosition({
      x: (stageWidth - boardWidth * nextScale) / 2,
      y: (stageHeight - boardHeight * nextScale) / 2,
    });
  }, [boardHeight, boardWidth]);

  useEffect(() => {
    fitStageToScreen();
    window.addEventListener("resize", fitStageToScreen);

    return () => window.removeEventListener("resize", fitStageToScreen);
  }, [fitStageToScreen]);

  const handleWheel = (e) => {
    e.evt.preventDefault();

    const stage = e.target.getStage();
    const pointer = stage.getPointerPosition();

    if (!pointer) {
      return;
    }

    const scaleMultiplier = 1.05;
    const oldScale = scale;
    const nextScale = e.evt.deltaY < 0
      ? Math.min(maxScale, oldScale * scaleMultiplier)
      : Math.max(minScale, oldScale / scaleMultiplier);

    const mousePointTo = {
      x: (pointer.x - position.x) / oldScale,
      y: (pointer.y - position.y) / oldScale,
    };

    setScale(nextScale);
    setPosition({
      x: pointer.x - mousePointTo.x * nextScale,
      y: pointer.y - mousePointTo.y * nextScale,
    });
  };

  return (
    <div className="mt-16 flex h-[calc(100vh-4rem)] w-screen items-center justify-center overflow-hidden">
      <Stage
        ref={stageRef}
        width={window.innerWidth}
        height={Math.max(window.innerHeight - 64, 1)}
        scaleX={scale}
        scaleY={scale}
        x={position.x}
        y={position.y}
        onWheel={handleWheel}
        onDragEnd={(e) => setPosition({ x: e.target.x(), y: e.target.y() })}
        draggable
      >
        <Layer>
          {rounds.map((row, rowIndex) =>
            row.map((col, colIndex) => {
              const level = levels - Math.round(Math.abs(Math.round(row.length / 2) - colIndex) / 3);
              
              const x = Math.floor((colIndex + 2) / 3) * cellWidth + Math.floor((colIndex + 1) / 3) * conLineWidth + Math.floor((colIndex ) / 3) * conLineWidth;
              //const y = rowIndex * cellHeight;
              const y = yOffset + Math.floor((rowIndex)/2) * 1.1 * cellHeight + rowIndex % 2 * cellHeight;

              //console.log(`X: ${x}, col=${colIndex} cell=${Math.floor((colIndex + 2)/ 3) * cellWidth } line=${Math.floor((colIndex + 1) / 3) * conLineWidth} + ${Math.floor((colIndex ) / 3) * conLineWidth}`);
              console.log(`Y: ${y}, row=${rowIndex} base=${Math.floor((rowIndex)/2) * 1.5 * cellHeight } extra=${rowIndex % 2 * cellHeight}`);

              if (col.pair) {
                return (
                  <>

                    {y=== yOffset &&
                        <>
                          <Rect
                          key={`${rowIndex}-${colIndex}-rect`}
                          x={x}
                          y="0"
                          width={cellWidth}
                          height={cellHeight}
                          fill="yellow"
                          stroke="black"
                          strokeWidth={2}
                          cornerRadius={4}
                        />
                        <Text
                          key={`${rowIndex}-${colIndex}-text`}
                          x={x}
                          y="0"
                          width={cellWidth}
                          height={cellHeight}
                          text={`Kierros ${level}`}
                          fontSize={20}
                          align="center"
                          verticalAlign="middle"
                          fill="black"
                        />
                      </>
                    }
                    <Rect
                      key={`${rowIndex}-${colIndex}-rect`}
                      x={x}
                      y={y}
                      width={cellWidth}
                      height={cellHeight}
                      fill="white"
                      stroke="black"
                      strokeWidth={2}
                      cornerRadius={4}
                    />
                    <Text
                      key={`${rowIndex}-${colIndex}-text`}
                      x={x}
                      y={y}
                      width={cellWidth}
                      height={cellHeight}
                      text={col.player}
                      fontSize={20}
                      align="center"
                      verticalAlign="middle"
                      fill="black"
                    />
                  </>
                );
              } else if(y===yOffset && colIndex % 3 === 0) {
                return (<>
                          <Rect
                          key={`${rowIndex}-${colIndex}-rect`}
                          x={x}
                          y="0"
                          width={cellWidth}
                          height={cellHeight}
                          fill="yellow"
                          stroke="black"
                          strokeWidth={2}
                          cornerRadius={4}
                        />
                        <Text
                          key={`${rowIndex}-${colIndex}-text`}
                          x={x}
                          y="0"
                          width={cellWidth}
                          height={cellHeight}
                          text={`Kierros ${level}`}
                          fontSize={20}
                          align="center"
                          verticalAlign="middle"
                          fill="black"
                        />
                      </>);
              } else if (col.bleft && col.btop) {
                return (
                    <>
                    <Rect
                    key={`${rowIndex}-${colIndex}-top-border`}
                    x={x}
                    y={y-3}
                    width={conLineWidth}
                    height={6}  
                    fill="yellow" 
                  />  
                  <Rect
                    key={`${rowIndex}-${colIndex}-left-corner`}
                    x={x}
                    y={y}
                    width={6}         // thickness
                    height={cellHeight}       // length of left border
                    fill="yellow"
                  />
                  </>
                );
              }  else if (col.btop) {
                return (
                  <Rect
                    key={`${rowIndex}-${colIndex}-top-border`}
                    x={x}
                    y={y-3}
                    width={conLineWidth}
                    height={6}  
                    fill="yellow" 
                  />
                );
              }  
               else if (col.bleft) {
                return (
                  <Rect
                    key={`${rowIndex}-${colIndex}-left-corner`}
                    x={x}
                    y={y-3}
                    width={6}         // thickness
                    height={cellHeight+6}       // length of left border
                    fill="yellow"
                  />
                );
              } else {

                return null;
                /*
                return (
                  <Rect
                    key={`${rowIndex}-${colIndex}-empty`}
                    x={x}
                    y={y}
                    width={conLineWidth}
                    height={cellHeight}
                    stroke="white"
                    strokeWidth={0}
                  />
                );
                */
              }
            })
          )}
        </Layer>
      </Stage>
    </div>
  );
}